<template>
  <div class="page">
    <mt-loadmore :top-method="loadTop" :bottom-method="loadBottom" :bottom-all-loaded="allLoaded" ref="loadmore">
      <div v-for="item in feedbackList" :key="item.id" class="feedback">
        <div class="head">
          <span>{{item.user_name + ' ' + item.user_code}}</span>
        </div>
        <div class="content">
          {{item.content}}
        </div>
        <div class="date">
          <span>提交日期：{{item.feedback_time}}</span>
        </div>
      </div>
    </mt-loadmore>
  </div>
</template>

<script>
import MainService from '@/service/main'
export default {
  name: 'Feedback',
  data () {
    return {
      feedbackList: [],
      allLoaded: false
    }
  },
  created () {
    this.initData(0, '')
  },
  methods: {
    initData (id, type) {
      this.$indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle'
      })
      MainService.getFeedback(id)
        .then(res => {
          if (res.data.result_code === 200) {
            if (id === 0) this.feedbackList = []
            if (this.feedbackList.length === 0) {
              this.feedbackList = res.data.data
            } else {
              this.feedbackList.push(...res.data.data)
            }
            if (type === 'bottom' && res.data.data.length === 0) this.allLoaded = true
            if (type === 'top') this.$refs.loadmore.onTopLoaded()
            else if (type === 'bottom') {
              this.$refs.loadmore.onBottomLoaded()
            }
          } else {
            this.$messagebox.alert({
              message: '获取数据失败！',
              title: '提示信息',
              showCancelButton: false
            })
          }
        })
        .catch(res => {
          console.log(res)
        })
        .finally(() => this.$indicator.close())
    },
    loadTop () {
      this.initData(0, 'top')
    },
    loadBottom () {
      let minId = 0
      if (this.feedbackList.length > 0) {
        minId = this.feedbackList[this.feedbackList.length - 1].id
      }

      this.initData(minId, 'bottom')
    }
  }
}
</script>

<style scoped>
  .page {
    width: 100%;
    padding: 0;
    margin: 0;
  }

  .feedback {
    background-color: #fff;
    width: 100%;
    padding: 10px 15px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    margin-bottom: 5px;
  }

  .feedback .head {
    font-size: 16px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  .feedback .content, .feedback .date {
    color: #888;
    font-size: 12px;
    margin-top: 10px;
    border-top: 1px solid #f8f8f9;
    padding-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Feedback.vue